import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import UserReflectionScreen from '../screen'
//<Route exact path={`${CLIENT_ENDPOINTS.PROFILE}${CLIENT_ENDPOINTS.USER_REFLECTION}`} component={UserReflectionScreen} />
const UsersRoutes = () => {
    return (
        <React.Fragment>
            <Route exact path={CLIENT_ENDPOINTS.USER_REFLECTION} component={UserReflectionScreen} />
        </React.Fragment>
    )
}

export default UsersRoutes